export const PRODUCT_TYPES = [
  { value: "life", label: "Life" },
  { value: "health", label: "Health" },
  { value: "motor", label: "Motor" },
  { value: "general", label: "General" },
];

export const POLICY_STATUSES = [
  { value: "active", label: "Active" },
  { value: "pending_renewal", label: "Pending Renewal" },
  { value: "lapsed", label: "Lapsed" },
  { value: "cancelled", label: "Cancelled" },
];

export const PAYMENT_MODES = [
  { value: "Monthly", label: "Monthly" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "Half-Yearly", label: "Half-Yearly" },
  { value: "Annual", label: "Annual" },
  { value: "Single", label: "Single" },
];

export const STATUS_STYLES = {
  active: "bg-primary/10 text-primary border-primary/20",
  pending_renewal: "bg-accent/15 text-accent border-accent/30",
  lapsed: "bg-muted text-muted-foreground border-border",
  cancelled: "bg-destructive/10 text-destructive border-destructive/20",
};

export const ROLES = ["admin", "agent", "accountant", "sales"];

// Where each role lands after login / on the index route. Sales is scoped to
// the Quick Grid Finder + Quick Reconcile pages, so it starts on the finder
// (the dashboard is not part of its allowed surface).
export function landingPathForRole(role) {
  return role === "sales" ? "/grid-finder" : "/dashboard";
}

// Insurers offered wherever a grid is tied to an insurer by hand (upload,
// image scans). The server turns the name into the insurer id.
export const KNOWN_INSURERS = [
  "National Insurance",
  "New India Assurance",
  "Oriental Insurance",
  "United India Insurance",
  "HDFC ERGO",
  "ICICI Lombard",
  "TATA AIG",
  "Bajaj Allianz",
  "Reliance General",
  "IndusInd General",
  "SBI General",
  "Royal Sundaram",
  "Future Generali",
  "Liberty General",
  "Magma HDI",
  "Universal Sompo",
  "Shriram General",
  "Go Digit",
  "Kotak General",
  "Cholamandalam MS",
  "IFFCO Tokio",
];
